import {register} from '@shopify/theme-sections';

register('article-template', {
  // onLoad() {},
});
